export class TblLeadSubStatus {
    refNo: number;
    statusRefNo:number;
    subStatusName: string;
    statusName: string;
    colorScheme: string;
    followupRequired: string;
  }
  